import { render, staticRenderFns } from "./PromptBar.vue?vue&type=template&id=2626a331&"
import script from "./PromptBar.vue?vue&type=script&lang=js&"
export * from "./PromptBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports